<svg width="86px" height="30px" viewBox="0 0 86 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
  <g id="Signup" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g transform="translate(-656.000000, -127.000000)">
      <g id="Check" transform="translate(656.000000, 127.000000)">
        <rect id="Rectangle" fill="#F1F2F5" x="0" y="0" width="86" height="30"></rect>
        <rect id="Rectangle" fill-opacity="0.400697401" fill="#0BBB00" x="5" y="18" width="28" height="8"></rect>
        <rect id="Rectangle" fill-opacity="0.254703548" fill="#7D7E80" x="5" y="4" width="18" height="3"></rect>
        <rect id="Rectangle" fill-opacity="0.254703548" fill="#7D7E80" x="5" y="8" width="18" height="3"></rect>
        <rect id="Rectangle" fill-opacity="0.466006406" fill="#6E42FF" x="37" y="18" width="18" height="8"></rect>
      </g>
    </g>
  </g>
</svg>
